<template>
  <div class="app-container subject-lib-list">
    <basic-container class = "subject-lib-list-container">
      <div class="subject-lib-list-filter">
        <el-row>
          <el-col :span="15">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="8">
                  <el-input class="subject-lib-list-filter-value" v-model.trim="search.content" 
                    @keyup.enter.native="searchChange" placeholder="题目" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </el-col>
                <el-col :span="8">
                  <el-select class="subject-lib-list-filter-value" placeholder="类型" v-model="search.type" clearable size="small">
                    <el-option
                      v-for="item in subjectTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="9">
            <div>
              <el-button class="subject-lib-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
              <el-button class="subject-lib-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <avue-crud
          ref="crud"
          :option="tableOption"
          :data="tableData"
          :page="page"
          :table-loading="tableLoading"
          :before-open="handleOpenBefore"
          @refresh-change="getList"
          @current-change="handleCurrentChange"
          @selection-change="selectionChange"
          @size-change="handleSizeChange">

        <template slot="menuLeft">
              <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.subject_lib_add">添加题目</el-button>
              <el-button v-if="permissions.subject_lib_add" lass="filter-item" size="small" type="primary" :loading="importLoading" @click="handleImport()" 
                icon="el-icon-upload2">
                {{importName}}
              </el-button>
              <el-button type="danger" @click="handleDeletedList" icon="el-icon-delete" size="small" v-if="permissions.subject_lib_del">批量删除</el-button>
        </template>
        <template slot-scope="scope"
          slot="menu">
          <el-button type="text"
            v-if="permissions.subject_lib_edit"
            icon="el-icon-edit"
            size="mini"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.subject_lib_del"
            icon="el-icon-delete"
            size="mini"
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog
      title="导入题目"
      :visible.sync="importSubjectVisible"
      width="600px">
      <div>
        <div style="margin-bottom: 10px">
          <span>1. 下载模板，并按照模板中的使用说明填写题目，</span>
          <span style="color: red;">切勿更改表结构（如删除某列)</span>
        </div>
        <el-button v-if="permissions.subject_lib_add" size="small" @click="handleImportTemplate()" 
        icon="el-icon-download">下载模板</el-button>
      </div>
      <div style="margin-top: 10px">
        <div style="margin-bottom: 10px">
          <span>2. 选择填写完成的模板文档</span>
        </div>
        <el-upload
          ref="csvUploader"
          class="upload-dialog"
          drag
          action=""
          accept=".csv,.xls,.xlsx"
          :on-change="handleFileChange"
          :http-request="uploadCsvFile"
          :show-file-list="false">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将填好的模板文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </div>
      <span slot="footer">
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="subjectDialogVisible"
      :title="dialogTitle"
      width="680px"
      :destroy-on-close="true"
      @close="closeDialog">
      <div class="heard">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :disabled="isEdit" :label="item.label" :name="item.value" v-for="item in subjectTypeList" :key="item.value"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="content">
        <el-form ref="subjectForm" :model="subjectForm" :rules="rules" label-width="80px">
          <el-form-item label="题干" prop="content">
            <el-input type="textarea" v-model="subjectForm.content"></el-input>
            <div class="upload-image">
              <div class="option-image-item" v-if="subjectForm.pictureUrl">
                <img :ref="pictureUrl" class="image-url-options" style="margin-top: 10px;" :src="subjectForm.pictureUrl">
                <el-button type="text"
                  style="margin-top: 7px;"
                  @click="handleImageRemove(index, 'content')"
                  icon="icon-remove-image"
                  class="image-remove-icon"></el-button>
              </div>
              <el-upload
                class="upload-image"
                v-else
                action=""
                accept="image/jpeg, image/png, image/gif"
                :on-change="(file, fileList) => { handleImageChange(file, fileList, index, 'content') }"
                :auto-upload="false"
                :multiple="false"
                :show-file-list="false">
                <el-button type="text"  icon="el-icon-picture-outline" style="font-size:20px"></el-button>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item v-if=" activeName === 1 || activeName === 2 " label="选项" required>
            <el-row class="subject-option-row" gutter="20" type="flex" justify="space-between" v-for="(item, index) in subjectForm.choices" :key="index">
              <el-col :span="24">
                <el-form-item :prop="'choices.' + index + '.content'" 
                    :rules="{required: true, message: '选项不能为空', trigger: 'blur'}" 
                    :label="calculatelabel(index)" label-width="30px">
                  <el-input v-model="item.content"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="12">
                    <div class="upload-image">
                      <div class="option-image-item" v-if="item.pictureUrl">
                        <img :ref="'imageUrlOptions' + index" class="image-url-options" :src="item.pictureUrl">
                        <el-button type="text"
                          @click="handleImageRemove(index, 'option')"
                          icon="icon-remove-image"
                          class="image-remove-icon"></el-button>
                      </div>
                      <el-upload
                        class="upload-image"
                        v-else
                        action=""
                        accept="image/jpeg, image/png, image/gif"
                        :on-change="(file, fileList) => { handleImageChange(file, fileList, index, 'option') }"
                        :auto-upload="false"
                        :multiple="false"
                        :show-file-list="false">
                        <el-button type="text"  icon="el-icon-picture-outline" style="font-size:20px"></el-button>
                      </el-upload>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-button type="text" icon="el-icon-delete" style="font-size:20px" v-if="subjectForm.choices.length !== 2" @click="optionDel(index)"></el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="optionAdd(index)">添加</el-button>
          </el-form-item>
          <el-form-item label="标准答案" required>
            <!-- <el-input type="textarea" v-model="subjectForm.subjectAnalyze"></el-input> -->
            <el-radio-group 
              v-if=" activeName === 1 || activeName === 3 " 
              v-model="subjectForm.answer.expect[0]" >
              <div v-if=" activeName === 1 ">
                <el-radio v-for="(item, index) in subjectForm.choices" :key="index" :label="calculatelabel(index)"></el-radio>
              </div>
              <div v-if="activeName === 3 ">
                <el-radio label="A">对</el-radio>
                <el-radio label="B">错</el-radio>
              </div>
            </el-radio-group>
            <el-checkbox-group 
              v-if=" activeName === 2 "
              min="1"
              v-model="subjectForm.answer.expect">
              <el-checkbox v-for="(item, index) in subjectForm.choices" :key="index" :label="calculatelabel(index)"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="题解">
            <el-input type="textarea" v-model="subjectForm.answer.analysis"></el-input>
          </el-form-item>
          <el-form-item label="题解链接" prop="answer.analysisUrl">
            <el-input type="text" v-model="subjectForm.answer.analysisUrl"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <template v-if="isEdit">
          <el-button @click="closeDialog">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="subjectEdit">修改</el-button>
        </template>
        <template v-else>
          <el-button @click="closeDialog">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="subjectSumbit">确认</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSubjectList, deleteSubject, editSubject, createSubject, getSubjectDetail, deleteSubjects, importSubjectList, downloadSubjectImportTemplate } from '@/api/app/subject'
import { subjectTableOption, subjectTypeList } from '@/const/crud/app/subject-lib'
import { mapGetters } from 'vuex'
import uploadService from '@/common/common-logic/upload-service';
import { getFileKeyAsync } from '@/util/util'
import { getOSSExam } from '@/api/basic/aliyunoss';

export default {
  name: 'subject',
  props: {
    libId: '',
  },
  data() {
    return {
      tableOption: subjectTableOption,
      subjectTypeList,
      search: {
        current: 1,
        size: 10,
        content: '',
        type: ''
      },
      groupList: [],
      // 列表页面
      tableData:[],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      importLoading: false,
      importName: '导入题目',
      importSubjectVisible: false,
      importSubjectFile: '',
      activeName: 1,
      tableLoading: false,
      subjectDialogVisible: false,
      isEdit: false,
      dialogTitle: '',
      selectSubjectList: [],
      subjectForm: this.initSubjectFrom(),
      rules: {
        content: [
          { required: true, message: '请输入题目', trigger: 'blur' },
        ],
        'answer.analysisUrl': [
          { pattern: /^((http|https):\/\/)?(([A-Za-z0-9]+-[A-Za-z0-9]+|[A-Za-z0-9]+)\.)+([A-Za-z]+)[/\?\:]?.*$/, message: '请输入正确的链接地址(http|https://xxx.com)' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
    this.getList();
  },
  mounted() {
  },
  methods: {
    initSubjectFrom() {
      return {
        label: '',
        type: 1,
        content: '',
        pictureUrl: '',
        choices: [
          {
            content: '',
            pictureUrl: '',
            flag: 'A'
          }, {
            content: '',
            pictureUrl: '',
            flag: 'B'
          }
        ],
        answer: {
          analysis: '',
          analysisUrl: '',
          expect: ['A'],
          freeSort: '',
          keyword: []
        },
      };
    },
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }
      params.libId = this.libId;
      if (this.search.content != "" && this.search.content.trim() != "") {
        params.content = this.search.content
      }
      if (this.search.type != "") {
        params.type = this.search.type
      }
      this.tableLoading = true
      getSubjectList(params).then(response => {
        this.tableData = response.data.data.records;
        this.tableData.forEach(record => {
          record.type = (subjectTypeList.find((v) => (v.value == record.type)) ? subjectTypeList.find((v) => (v.value == record.type)).label :'类型异常');
        })
        this.page.total = response.data.data.total
        this.tableLoading = false
      })
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.search.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.search.size = val
      this.getList()
    },
    initPage() {
      this.page.currentPage = 1
      this.page.pageSize = this.search.size
      this.search.current = 1
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.content = '',
      this.search.type = '',
      this.searchChange()
    },
    handleImport() {
      this.importSubjectVisible = true;
    },
    handleImportTemplate() {
      downloadSubjectImportTemplate()
        .then((response) => {
          if (response && response.data) {
            window.location = response.data.data;
          }
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
        });
    },
    handleFileChange(file, fileList) {
      if (!fileList || fileList.length === 0) {
        return false;
      }
      const fileTypes = ['xls', 'xlsx', 'csv'];
      const isVaildFileType = (file) => {
        const { name, type } = file.raw;
        return name && fileTypes.includes(name.split('.').pop());
      };
      if (!isVaildFileType(file)) {
        this.$message.error('上传文件只能是csv或excel格式的文件!');
        if (fileList.length > 1) {
          // 当文件数大于1只保留之前的文件
          fileList.splice(1, 1);
        } else {
          // 否则清空控件的所有文件
          this.$refs.csvUploader.clearFiles();
        }
        return false;
      }
      // 当文件数大于 1 时替换之前的文件
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.importSubjectVisible = false;
    },
    uploadCsvFile({ file }) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('libId', this.libId);

      this.importLoading = true;
      this.importName = '导入中...';
      importSubjectList(formData).then(() => {
        this.$message({
          showClose: true,
          message: '导入成功',
          type: 'success',
        });
        this.initPage();
        this.getList();
      })
      .catch(err => {
        this.$message.error(err);
      })
      .finally(() => {
        this.importLoading = false;
        this.importName = '导入题目';
      });
    },
    handleAdd() {
      this.dialogTitle = '新增';
      this.isEdit = false;
      this.subjectDialogVisible = true;
    },
    handleEdit(row, index) {
      this.dialogTitle = '编辑';
      this.isEdit = true;
      this.initDialog(row.id);
      this.subjectDialogVisible = true;
    },
    handleDeletedList() {
      if (this.selectSubjectList.length !=0){  
        this.$confirm("是否确认删除选中的所有题目吗？", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=> {
          deleteSubjects(this.selectSubjectList).then(response => {
            if (response.data.data) {
              if (response.data.data.failed.length > 0) {
                this.$message({
                  message: '部分题目已被使用，不进行删除，其余选中题目已删除',
                  type: 'warning'
                })
              } else {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
              }
              this.getList()
            }
          }).catch(error => {
            this.$message({
              message: error,
              type: 'error'
            })
          })
        })
      }else{
        this.$message.error('未选中任何题目')
      }
    },
    selectionChange(row) {
      this.selectSubjectList = []
      row.forEach(item => {
        this.selectSubjectList.push(item.id);
      })
    },
    initDialog(id) {
      getSubjectDetail(id).then(res => {
        this.subjectForm = res.data.data;
        this.activeName = this.subjectForm.type
        this.showSubject = true;
      }).catch(error => {
        this.$message({
          message: '获取题目详情失败',
          type: 'error'
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSubject(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          }
        }).catch(error => {
          this.$message({
            message: error,
            type: 'error'
          })
        })
      })
    },
    closeDialog() {
      this.isEdit = false;
      this.subjectDialogVisible = false;
      this.dialogTitle = '';
      this.activeName = 1;
      this.subjectForm = this.initSubjectFrom();
      this.$nextTick(()=>{
        this.$refs['subjectForm'].clearValidate();
      })
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      this.$refs['subjectForm'].clearValidate();
      this.subjectForm = this.initSubjectFrom();
      this.subjectForm.type = tab.name;
      // this.$confirm('切换类型将会清空内容？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //       this.activeName = tab.name;
      //       this.initSubjectFrom();
      //   })
    },
    calculatelabel(index) {
      return String.fromCharCode('A'.charCodeAt() + index);
    },
    optionAdd() {
      this.subjectForm.choices.push({
        content: '',
        pictureUrl: '',
        flag: ''
      });
    },
    optionDel(index) {
      if(this.subjectForm.choices === 2) return;

      this.subjectForm.choices.splice(index, 1);
      const labelValue = this.calculatelabel(index)
      if(this.activeName === 2 && this.subjectForm.answer.expect.indexOf(labelValue) !== -1){
        this.subjectForm.answer.expect.splice(this.subjectForm.answer.expect.indexOf(labelValue), 1);
      } else if (labelValue === this.subjectForm.answer.expect[0]){
        this.subjectForm.answer.expect[0] = 'A';
      }
    },
    formateOptionList() {
      this.subjectForm.choices.forEach((option, index) => {
        option.flag = this.calculatelabel(index);
      })
    },
    async handleImageChange (file, fileList, index, type) {
      if (!fileList || fileList.length === 0) {
        return false
      }
      const fileType = file.raw.type
      const isImage = fileType === 'image/jpeg'|| fileType === 'image/gif'|| fileType === 'image/png'
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!')
        if (fileList.length > 1) {
          // 当文件数大于1只保留之前的文件
          fileList.splice(1, 1)
        } else {
          // 否则清空控件的所有文件
          this.$refs['imageUrlOptions' + index].clearFiles()
        }
        return false
      }
      // 当文件数大于1时替换之前的文件
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      const key = await getFileKeyAsync(file.raw, getOSSExam());
      try {
        const response = await uploadService.uploadFiles([{
          key: key,
          file: file.raw
        }])
        if (type === 'content') {
          this. subjectForm.pictureUrl = response[0].fileUrl
        } else  if (type === 'option') {
          this.subjectForm.choices[index].pictureUrl = response[0].fileUrl
        }
      } catch (error) {
        this.$message({
          message: '上传失败',
          type: 'error'
        })
      }
      return false
    },
    handleImageRemove (index, type) {
      if (type === 'content') {
        this. subjectForm.pictureUrl = '';
        this.$refs['pictureUrl'].src = ''
      } else  if (type === 'option') {
        this.subjectForm.choices[index].pictureUrl = ''
        this.$refs['imageUrlOptions' + index].src = ''
      }
    },
    subjectSumbit() {
      this.formateOptionList();
      this.subjectForm.libId = this.libId;
      const params = Object.assign({}, this.subjectForm);
      this.$refs.subjectForm.validate((valid) => {
        if (valid) {
          createSubject(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              })
              this.closeDialog();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
            this.closeDialog();
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    },
    subjectEdit() {
      this.formateOptionList();
      this.subjectForm.libId = this.libId;
      const params = Object.assign({}, this.subjectForm);
      this.$refs.subjectForm.validate((valid) => {
        if (valid) {
          editSubject(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: ' 修改成功',
                type: 'success'
              })
              this.closeDialog();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
            this.closeDialog();
          })
        } else {
          this.$message({
            message: '请通过验证',
            type: 'error'
          })
          return false;
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.subject-lib-list {
  &-filter {
    padding-left: 8px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}

.dialog-body-row {
  line-height: 36px;
}

.operation-btn {
  font-size: 12px;
  border: none;
  color: #409EFF;
  background: transparent;
  i {
    position: relative;
    top: 3px;
    display: inline-block;
    margin-top: 2px;
    width: 13px;
    height: 13px;
    margin-right: 2px;
    background-size: 12px 12px;
  }
}

/deep/ .el-dialog.subject-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
.subject-option-row{
  margin-bottom: 20px;
}
.upload-image {
  .image-url-options{
    width: 62px;
    height: 62px;
    border-radius: 6px;
    margin-right: 8px;
    float: left;
    object-fit: cover;
  }
  .upload-image {
    width: 15px;
    height: 15px;
  }
  .option-image-item {
    display: inline;
    padding: 0;
  }
  .image-remove-icon {
    position: absolute;
    padding: 0;
    margin-top: -7px;
    margin-left: -7px;
    left: 60px;
  }
}
.head {
  width: 100%;
}
.upload-dialog {
  width: 100%;
  height: 100%;
  /deep/ .el-upload {
      .el-upload-dragger {
        background-color: #fff;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        box-sizing: border-box;
        width: 550px;
        height: 180px;
        text-align: center;
        position: relative;
        overflow: hidden;
      }
  }
}
</style>
